/* The Warm Chapter — shared front-end behaviour (no dependencies).
   Everything degrades gracefully: with JS off the page still reads and the
   first bundle stays selected. Shopify port: keep the data-* contract. */
(function () {
  'use strict';

  /* ---- 1. mobile nav ---- */
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.style.display === 'flex';
      nav.style.display = open ? '' : 'flex';
      nav.style.position = 'absolute';
      nav.style.top = '66px';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.background = '#fff';
      nav.style.flexDirection = 'column';
      nav.style.padding = '18px 20px';
      nav.style.borderBottom = '1px solid var(--line)';
      burger.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* ---- 2. bundle / option pickers ----
     Markup contract:
       [data-picker]            wrapper
         [data-option]          each card or row
            data-price="139.95" data-price-money="{{ v.price | money }}"
            data-compare="169.94" data-compare-money="{{ v.compare_at_price | money }}"
            data-variant="<id>" data-qty="1"
       [data-price-out]         span that shows the live price
       [data-compare-out]       span that shows the struck price (optional)
       [data-atc]               the add-to-cart button (gets data-variant + data-qty)
  */
  document.querySelectorAll('[data-picker]').forEach(function (picker) {
    var opts = Array.prototype.slice.call(picker.querySelectorAll('[data-option]'));
    var scope = picker.closest('[data-buy-scope]') || document;
    /* every price output in the buy scope, not just the first — the headline
       price, the button price and any future add-on total all stay in sync */
    var priceOuts = Array.prototype.slice.call(scope.querySelectorAll('[data-price-out]'));
    var compareOuts = Array.prototype.slice.call(scope.querySelectorAll('[data-compare-out]'));
    var atc = scope.querySelector('[data-atc]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyCompare = document.querySelector('[data-sticky-compare]');

    /* Prices are rendered by Liquid's `money` filter so they follow the
       active market's currency. JS only reuses those strings; the fallback
       formats with the shop's active currency, never a hardcoded symbol. */
    function fmt(v) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: cur
        }).format(Number(v));
      } catch (e) { return Number(v).toFixed(2) + ' ' + cur; }
    }
    function money(el, which) {
      var rendered = el.getAttribute('data-' + which + '-money');
      if (rendered) return rendered;
      var raw = el.getAttribute('data-' + which);
      return raw ? fmt(raw) : '';
    }

    /* ---- add-ons (e.g. "add heated socks") ----
       A ticked add-on has to move every displayed total, not just sit there.
       data-cents is the add-on's discounted price; its <s> is the full price. */
    var addons = Array.prototype.slice.call(scope.querySelectorAll('[data-addon]'));

    function addonCents() {
      return addons.reduce(function (sum, a) {
        var box = a.querySelector('[data-addon-check]');
        return sum + (box && box.checked ? (parseInt(a.getAttribute('data-cents'), 10) || 0) : 0);
      }, 0);
    }
    function addonFullCents() {
      return addons.reduce(function (sum, a) {
        var box = a.querySelector('[data-addon-check]');
        if (!box || !box.checked) return sum;
        var was = a.querySelector('.addon__p s');
        var cents = parseInt(a.getAttribute('data-cents'), 10) || 0;
        if (was) {
          var n = parseFloat(String(was.textContent).replace(/[^0-9.]/g, ''));
          if (!isNaN(n)) return sum + Math.round(n * 100);
        }
        return sum + cents;
      }, 0);
    }

    function select(el) {
      opts.forEach(function (o) {
        o.classList.toggle('is-selected', o === el);
        var r = o.querySelector('input[type="radio"]');
        if (r) r.checked = (o === el);
      });
      var extra = addonCents();
      var extraFull = addonFullCents();

      /* With no add-on ticked, reuse Liquid's exact `money` output. With one
         ticked we have to do arithmetic, so format it ourselves. */
      var base = parseFloat(el.getAttribute('data-price'));
      var p = extra && !isNaN(base) ? fmt(base + extra / 100) : money(el, 'price');

      var rawC = el.getAttribute('data-compare');
      var c;
      if (extraFull && rawC) {
        c = fmt(parseFloat(rawC) + extraFull / 100);
      } else if (extraFull && !isNaN(base)) {
        c = fmt(base + extraFull / 100);          // no tier discount, but the add-on has one
      } else {
        c = money(el, 'compare');
      }

      if (p) priceOuts.forEach(function (n) { n.textContent = p; });
      if (stickyPrice && p) stickyPrice.textContent = p;
      compareOuts.forEach(function (n) {
        n.textContent = c;
        n.style.display = c ? '' : 'none';
      });
      if (stickyCompare) { stickyCompare.textContent = c; stickyCompare.style.display = c ? '' : 'none'; }
      if (atc) {
        atc.setAttribute('data-variant', el.getAttribute('data-variant') || '');
        atc.setAttribute('data-qty', el.getAttribute('data-qty') || '1');
      }
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () { select(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(o); }
      });
    });

    var initial = picker.querySelector('[data-option].is-selected') || opts[0];
    if (initial) select(initial);

    /* ticking an add-on re-runs the same maths against the current tier */
    addons.forEach(function (a) {
      /* visibility is owned by twc-offer.js (real per-shopper window) */
      var box = a.querySelector('[data-addon-check]');
      if (!box) return;
      box.addEventListener('change', function () {
        a.classList.toggle('is-on', box.checked);
        var cur = picker.querySelector('[data-option].is-selected') || opts[0];
        if (cur) select(cur);
      });
      a.classList.toggle('is-on', box.checked);
    });

    /* the add-to-cart button carries whatever add-ons are ticked */
    var atcBtn = scope.querySelector('[data-atc]');
    if (atcBtn) {
      atcBtn.addEventListener('twc:collect-items', function (ev) {
        addons.forEach(function (a) {
          var box = a.querySelector('[data-addon-check]');
          var vid = a.getAttribute('data-variant');
          if (box && box.checked && vid) {
            ev.detail.items.push({ id: vid, quantity: 1 });
            var code = a.getAttribute('data-code');
            if (code) (ev.detail.codes = ev.detail.codes || []).push(code);
          }
        });
      });
    }
  });

  /* ---- 3. add to cart ----
     Static preview: logs + confirms. On Shopify, this POSTs to /cart/add.js
     and then refreshes the cart drawer section. */
  document.querySelectorAll('[data-atc], [data-xadd]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var id = btn.getAttribute('data-variant');
      var qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
      if (!id || id.indexOf('VARIANT') === 0) {
        e.preventDefault();
        console.log('[The Warm Chapter] wire this to /cart/add.js — variant:', id, 'qty:', qty);
        return;
      }
      e.preventDefault();
      btn.classList.add('is-loading');
      /* let the picker append any ticked add-ons to the same cart request */
      var payload = { items: [{ id: id, quantity: qty }] };
      btn.dispatchEvent(new CustomEvent('twc:collect-items', { detail: payload }));
      var codes = payload.codes || [];
      delete payload.codes;                      /* /cart/add.js rejects extras */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          /* add-on prices shown on the page are discount-code prices */
          if (!codes.length) return null;
          return Promise.all(codes.map(function (c) {
            return fetch('/discount/' + encodeURIComponent(c), { credentials: 'same-origin' })
                     .catch(function () {});
          }));
        })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) { console.error(err); })
        .then(function () { btn.classList.remove('is-loading'); });
    });
  });

  /* ---- 4. product gallery ---- */
  var gal = document.querySelector('[data-gallery]');
  if (gal) {
    var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-thumb]'));
    var counter = gal.querySelector('[data-gal-count]');
    var i = 0;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = gal.querySelector('[data-gal-prev]');
    var next = gal.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });

    /* swipe */
    var x0 = null;
    gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    }, { passive: true });

    show(0);
  }

  /* ---- 5. sticky mobile ATC (appears once the buy box scrolls away) ---- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-sticky-trigger]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-atc');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---- 6. timeline scroll fill ---- */
  var tl = document.querySelector('[data-timeline]');
  if (tl) {
    var rows = Array.prototype.slice.call(tl.querySelectorAll('.tl__row'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.querySelector('.tl__dot').style.background = 'var(--ember)';
            en.target.style.opacity = 1;
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.3 });
      rows.forEach(function (r) {
        r.style.opacity = 0.45;
        r.style.transition = 'opacity .5s ease';
        io.observe(r);
      });
    }
  }
})();

/* ---------- dispatch countdown (real 2pm America/Denver cutoff) ---------- */
(function(){
  function cutoff(){
    var now=new Date(),
        den=new Date(now.toLocaleString('en-US',{timeZone:'America/Denver'})),
        skew=now-den, c=new Date(den);
    c.setHours(14,0,0,0);
    if(den>=c) c.setDate(c.getDate()+1);
    while(c.getDay()===0||c.getDay()===6) c.setDate(c.getDate()+1);
    return new Date(c.getTime()+skew);
  }
  var t=cutoff(), pad=function(n){return String(n).padStart(2,'0');};
  function tick(){
    var d=t-new Date(); if(d<=0){ t=cutoff(); d=t-new Date(); }
    var h=Math.floor(d/3.6e6), m=Math.floor(d%3.6e6/6e4), s=Math.floor(d%6e4/1000);
    document.querySelectorAll('[data-clock]').forEach(function(el){
      var p=el.querySelectorAll('i');
      if(p[0])p[0].textContent=pad(h); if(p[1])p[1].textContent=pad(m); if(p[2])p[2].textContent=pad(s);
    });
  }
  if(document.querySelector('[data-clock]')){ tick(); setInterval(tick,1000); }
})();

/* ---------- sticky sub-nav active state ---------- */
(function(){
  var links=[].slice.call(document.querySelectorAll('.subnav a[href^="#"]'));
  if(!links.length||!('IntersectionObserver' in window)) return;
  var secs=links.map(function(a){return document.querySelector(a.getAttribute('href'));}).filter(Boolean);
  if(!secs.length) return;
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(!e.isIntersecting)return;
      links.forEach(function(a){a.classList.toggle('on', a.getAttribute('href')==='#'+e.target.id);});});
  },{rootMargin:'-45% 0px -50% 0px'});
  secs.forEach(function(x){io.observe(x);});
})();

/* ---------- size selects must not re-pick the tier ---------- */
(function(){
  document.querySelectorAll('[data-picker] select, [data-picker] .size__r label').forEach(function(el){
    ['click','mousedown','keydown'].forEach(function(ev){
      el.addEventListener(ev,function(e){ e.stopPropagation(); });
    });
  });
  /* the chosen variant comes from the selected tier's first size picker */
  document.querySelectorAll('[data-picker] [data-size]').forEach(function(sel){
    sel.addEventListener('change',function(){
      var opt=sel.closest('[data-option]');
      if(opt && sel.dataset.pair==='1') opt.dataset.variant=sel.value;
    });
  });
})();


/* ---------- UGC video rail: autoplay muted in view, tap for sound ---------- */
(function(){
  function init(root){
    root = root || document;
    var items = [].slice.call(root.querySelectorAll('[data-ugc-item]'));
    if(!items.length) return;

    function setPlaying(wrap, on){
      wrap.classList.toggle('is-playing', on);
      var p = wrap.querySelector('[data-ugc-icon-play]'),
          q = wrap.querySelector('[data-ugc-icon-pause]');
      if(p) p.classList.toggle('is-hidden', on);
      if(q) q.classList.toggle('is-hidden', !on);
    }
    items.forEach(function(wrap){
      var v = wrap.querySelector('[data-ugc-video]');
      if(!v) return;
      var toggle = wrap.querySelector('[data-ugc-toggle]'),
          sound  = wrap.querySelector('[data-ugc-sound]');
      if(toggle) toggle.addEventListener('click', function(){
        if(v.paused){
          items.forEach(function(o){ var ov=o.querySelector('[data-ugc-video]');
            if(ov && ov!==v && !ov.paused){ ov.pause(); setPlaying(o,false); } });
          v.play().catch(function(){});
        } else { v.pause(); }
      });
      if(sound) sound.addEventListener('click', function(){
        v.muted = !v.muted;
        sound.setAttribute('aria-pressed', String(!v.muted));
        sound.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute');
        var m = sound.querySelector('[data-ugc-icon-muted]'), l = sound.querySelector('[data-ugc-icon-loud]');
        if(m) m.classList.toggle('is-hidden', !v.muted);
        if(l) l.classList.toggle('is-hidden', v.muted);
        if(v.paused) v.play().catch(function(){});
      });
      v.addEventListener('play',  function(){ setPlaying(wrap,true); });
      v.addEventListener('pause', function(){ setPlaying(wrap,false); });
    });

    /* only load and play what is actually on screen — keeps the page light */
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          var v = e.target.querySelector('[data-ugc-video]');
          if(!v) return;
          if(e.isIntersecting){
            if(v.preload === 'none') v.preload = 'metadata';
            if(v.muted) v.play().catch(function(){});
          } else if(!v.paused){ v.pause(); }
        });
      }, { threshold: 0.6 });
      items.forEach(function(i){ io.observe(i); });
    }

    [].slice.call(root.querySelectorAll('[data-ugc-rail]')).forEach(function(rail){
      var sec = rail.closest('section') || document;
      var prev = sec.querySelector('[data-ugc-prev]'), next = sec.querySelector('[data-ugc-next]');
      function step(dir){
        var card = rail.querySelector('.ugc__i');
        var w = card ? card.getBoundingClientRect().width + 14 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      if(prev) prev.addEventListener('click', function(){ step(-1); });
      if(next) next.addEventListener('click', function(){ step(1); });
    });
  }
  init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();


/* ---------- dot pagination + smooth scroll for every horizontal rail ---------- */
(function(){
  function build(rail){
    if(rail.dataset.dots === 'on') return;
    var items = [].slice.call(rail.children).filter(function(n){ return n.nodeType === 1; });
    if(items.length < 2) return;
    rail.dataset.dots = 'on';

    var dots = document.createElement('ul');
    dots.className = 'rail-dots';
    items.forEach(function(item, i){
      var li = document.createElement('li');
      var b  = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1));
      b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function(){
        rail.scrollTo({ left: item.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      });
      li.appendChild(b); dots.appendChild(li);
    });
    rail.parentNode.insertBefore(dots, rail.nextSibling);

    var btns = [].slice.call(dots.querySelectorAll('button'));
    function sync(){
      var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, dist = Infinity;
      items.forEach(function(item, i){
        var c = item.offsetLeft - rail.offsetLeft + item.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if(d < dist){ dist = d; best = i; }
      });
      btns.forEach(function(b, i){ b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
    }
    var tick;
    rail.addEventListener('scroll', function(){
      if(tick) return;
      tick = requestAnimationFrame(function(){ tick = null; sync(); });
    }, { passive: true });
    sync();
  }

  function init(root){
    root = root || document;
    [].slice.call(root.querySelectorAll('[data-ugc-rail],[data-prv-rail],[data-rail]')).forEach(build);
  }
  init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

/* ---------- review wall: Read more toggles the full review ---------- */
(function(){
  function wire(scope){
    (scope||document).querySelectorAll('[data-tpx-more]').forEach(function(btn){
      if(btn.dataset.wired) return; btn.dataset.wired='1';
      var card=btn.closest('.tpx__card');
      btn.addEventListener('click',function(){
        var open=card.classList.toggle('is-open');
        btn.textContent=open?'Read less':'Read more';
      });
    });
  }
  wire(document);
  document.addEventListener('shopify:section:load',function(e){ wire(e.target); });
})();

/* ---------- cart drawer add-on: one click, then re-render the drawer ---------- */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-twc-ca-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant');
    if (!id || btn.disabled) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        /* the displayed price is a discount-code price, so apply the code —
           without this the customer is charged full price for the add-on */
        var code = btn.getAttribute('data-code');
        return code ? fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
                        .catch(function () {}) : null;
      })
      .then(function () {
        /* pull a fresh drawer rather than reloading the page */
        return fetch(window.location.pathname + '?sections=cart-drawer-section')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data['cart-drawer-section'];
            var host = document.querySelector('cart-drawer-component');
            if (html && host) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('cart-drawer-component');
              if (fresh) { host.innerHTML = fresh.innerHTML; return; }
            }
            window.location.reload();
          });
      })
      .catch(function (err) {
        console.error(err);
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
